/* global angular */
( function () {
	'use strict';

	function pdfPreviewCtrl ( pdfDetails, $modalInstance, $scope ) {
		var self = this;

		self.pdfName     = pdfDetails.pdfName;
		self.showLoading = true;
		self.hasData     = pdfDetails.hasData;
		self.title       = pdfDetails.pdfName;

		function hideLoading () {
			self.showLoading = false;
		}

		function closeModal () {
			$modalInstance.dismiss( 'cancel' );
		}

		self.closeModal = closeModal;

		// angular-pdf defined variables
		$scope.pdfUrl = pdfDetails.pdfUrl;
		$scope.onLoad = hideLoading;
	}

	angular
		.module( 'app.templates' )
		.controller( 'pdfPreviewCtrl', pdfPreviewCtrl );

	pdfPreviewCtrl.$inject = [ 'pdfDetails', '$modalInstance', '$scope' ];
} )( );
